// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---content-guidelines-design-mdx": () => import("./../../../content/guidelines/design.mdx" /* webpackChunkName: "component---content-guidelines-design-mdx" */),
  "component---content-guidelines-index-mdx": () => import("./../../../content/guidelines/index.mdx" /* webpackChunkName: "component---content-guidelines-index-mdx" */),
  "component---content-guidelines-usage-mdx": () => import("./../../../content/guidelines/usage.mdx" /* webpackChunkName: "component---content-guidelines-usage-mdx" */),
  "component---content-index-mdx": () => import("./../../../content/index.mdx" /* webpackChunkName: "component---content-index-mdx" */),
  "component---src-templates-icon-page-js": () => import("./../../../src/templates/icon-page.js" /* webpackChunkName: "component---src-templates-icon-page-js" */)
}

